import { render, staticRenderFns } from "./CustomTinymceEditor.vue?vue&type=template&id=b56ac7ea&"
import script from "./CustomTinymceEditor.vue?vue&type=script&lang=js&"
export * from "./CustomTinymceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56ac7ea')) {
      api.createRecord('b56ac7ea', component.options)
    } else {
      api.reload('b56ac7ea', component.options)
    }
    module.hot.accept("./CustomTinymceEditor.vue?vue&type=template&id=b56ac7ea&", function () {
      api.rerender('b56ac7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomInputComponents/CustomTinymceEditor.vue"
export default component.exports